import axios, { AxiosResponse } from "axios";
import { useContext } from "react";
import { AppContext } from "../components/Store";
import Endpoint from "../endpoints/Endpoint";
import { axiosConfig } from "../utils/Utils";

interface RegistarControllerType {
  axiosRegistarById: Function;
  axiosParametarRegistarList: Function;
  axiosPretraga: (paramsPretraga: any) => Promise<AxiosResponse<any>>;
  axiosTipSkupaAtributaByRegistar: Function;
  axisGetAtributUTipuSkupaByRegistar: Function;
  axiosBrojUnosaPoPacijentu: (params: any) => Promise<AxiosResponse<any>>;
  axiosTipSkupaAtributaByTipSkupaAtributa: Function;
  axiosEnumStavkaByAUTS: Function;
  axiosAtributUTipuSkupaFindTVAByAUTS: Function;
  axiosRegistarPacijentPolja: Function;
  axiosTipSkupaAtributaByRegistarAndMozeDaInstancira: Function;
  axiosCheckUnosLimit: (params: { pacijentID: number; unosID: number; datum: string }) => Promise<AxiosResponse<boolean>>;
}

export function RegistarController(): RegistarControllerType {
  const { authData } = useContext(AppContext);
  const { token } = authData;

  const registarID = JSON.parse(localStorage.getItem("odabraniRegistar") || "null");
  const registarParams = { registar: `${Endpoint.REGISTAR}/${registarID}` };

  const axiosRegistarById = () => axios.get(registarParams.registar, axiosConfig(token));

  const axiosParametarRegistarList = () => axios.get(Endpoint.PARAMETAR + "/registri", axiosConfig(token));

  const axiosPretraga = (paramsPretraga: any) => axios.post(Endpoint.PRETRAGA, { ...paramsPretraga, registarID: registarID }, axiosConfig(token));

  const axiosTipSkupaAtributaByRegistar = () => axios.get(Endpoint.TIP_SKUPA_ATRIBUTA + "/search/findTipSkupaAtributaByRegistar", axiosConfig(token, registarParams));

  const axiosTipSkupaAtributaByRegistarAndMozeDaInstancira = () =>
    axios.get(Endpoint.TIP_SKUPA_ATRIBUTA + "/search/findTipSkupaAtributaByRegistarAndMozeDaInstancira", axiosConfig(token, registarParams));

  const axisGetAtributUTipuSkupaByRegistar = () => axios.get(Endpoint.ATRIBUT_U_TIPU_SKUPA + "/search/findAtributUTipuSkupaByRegistar", axiosConfig(token, registarParams));

  const axiosBrojUnosaPoPacijentu = (params: any) => axios.get(Endpoint.BROJ_UNOSA_PO_PACIJENTU, axiosConfig(token, params));

  const axiosTipSkupaAtributaByTipSkupaAtributa = (params: any) =>
    axios.get(Endpoint.ATRIBUT_U_TIPU_SKUPA + "/search/findByTipSkupaAtributaAndAktivanZaPretraguOrderByRedosledAsc", axiosConfig(token, params));

  const axiosEnumStavkaByAUTS = (params: any) => axios.get(Endpoint.ENUM_STAVKA + "/search/findEnumStavkaByAUST", axiosConfig(token, params));

  const axiosAtributUTipuSkupaFindTVAByAUTS = (params: any) => axios.get(Endpoint.ATRIBUT_U_TIPU_SKUPA + "/search/findTipVrednostiAtributaByAtributUTipuSkupa", axiosConfig(token, params));

  const axiosRegistarPacijentPolja = () => axios.get(Endpoint.REGISTAR_PACIJENT_POLJE + "/search/findByRegistarAndAktivan", axiosConfig(token, { ...registarParams, aktivan: true }));

  const axiosCheckUnosLimit = (params: { pacijentID: number; unosID: number; datum: string }) => axios.get(`${Endpoint.REGISTAR_JEDAN}/checkUnosLimit`, axiosConfig(token, params));

  return {
    axiosRegistarById,
    axiosParametarRegistarList,
    axiosPretraga,
    axiosTipSkupaAtributaByRegistar,
    axisGetAtributUTipuSkupaByRegistar,
    axiosBrojUnosaPoPacijentu,
    axiosTipSkupaAtributaByTipSkupaAtributa,
    axiosEnumStavkaByAUTS,
    axiosAtributUTipuSkupaFindTVAByAUTS,
    axiosRegistarPacijentPolja,
    axiosTipSkupaAtributaByRegistarAndMozeDaInstancira,
    axiosCheckUnosLimit,
  };
}

// export type { RegistarControllerType };
